// Official "O*NET in-it" logo linking to O*NET Web Services (license requirement).
export function OnetBadge({ className = "", onDark = false }) {
  const img = (
    <img src="https://www.onetcenter.org/image/link/onet-in-it.svg"
      alt="O*NET in-it" className="h-6 w-auto" />
  );
  return (
    <a href="https://services.onetcenter.org/" target="_blank" rel="noreferrer"
      aria-label="O*NET in-it — visit O*NET Web Services" data-testid="onet-in-it-logo"
      className={`inline-flex items-center ${onDark ? "rounded bg-white px-2 py-1" : ""} ${className}`}>
      {img}
    </a>
  );
}
